// extends
import { ExtendedContainer, ExtendedSprite, SkySpine } from "@aceroll/core";

// gameObjects
import BackgroundFire from "./BackgroundFire";

// constants
import { GAME_MODE, ORIENTATIONS } from "../constants";

const ANIMATIONS = {
    IDLE: 'idle',
    PYRAMID_STATIC: "static",
    WIN: "win",
    WIN_END: "end"
};

class Background extends ExtendedContainer {
    constructor() {
        super('background-container');

        this._orientation = ORIENTATIONS.LANDSCAPE;
        this._mode = GAME_MODE.MAIN;

        this._content = this.addChild(new ExtendedContainer('background'));
        this._mainGameBackground = ExtendedSprite.fromAlias('img-background_main');
        this._bonusGameBackgroundLandscape = ExtendedSprite.fromAlias('img-background_bonus_landscape');
        this._bonusGameBackgroundPortrait = ExtendedSprite.fromAlias('img-background_bonus_portrait');

        this._bonusGameAnimation = new SkySpine('spine-bonus_columns');
        this._bonusGamePyramid = new SkySpine('spine-bonus_pyramid');

        this._bonusGamePyramid.setSkin('bonus');

        this.fireAnimation = new BackgroundFire();

        this._content.addChild(this._mainGameBackground);
        this._content.addChild(this._bonusGameBackgroundLandscape);
        this._content.addChild(this._bonusGameBackgroundPortrait);

        this._content.pivot.set(this._content.width / 2, this._content.height / 2);

        this._content.addChild(this._bonusGameAnimation);
        this._content.addChild(this._bonusGamePyramid);
        this._content.addChild(this.fireAnimation);

        this.fireAnimation.position.set(958, 988);
        this._bonusGameAnimation.position.set(960, 960);
        this._bonusGamePyramid.position.set(965, 875);
        this._bonusGamePyramid.scale.set(1.05, 1.05);

        this.fireAnimation.start();

        this.setMainGameView();
    }

    setMainGameView() {
        this._mode = GAME_MODE.MAIN;

        this.fireAnimation.setMainGameView();
        this._bonusGameAnimation.visible = false;
        this._bonusGamePyramid.visible = false;
        this._mainGameBackground.visible = true;
        this._bonusGameBackgroundLandscape.visible = false;
        this._bonusGameBackgroundPortrait.visible = false;

        if (this.isLandscape) {
            this._bonusGameAnimation.stop(true);
            this._bonusGameAnimation.visible = false;
        } else {
            this._bonusGamePyramid.stop(true);
            this._bonusGamePyramid.visible = false;
        }
    }

    setBonusGameView() {
        this._mode = GAME_MODE.BONUS;

        this.fireAnimation.setBonusGameView();
        this._mainGameBackground.visible = false;
        this._bonusGameBackgroundLandscape.visible = this.isLandscape;
        this._bonusGameBackgroundPortrait.visible = !this.isLandscape;

        if (this.isLandscape) {
            this._bonusGameAnimation.setImmediately(ANIMATIONS.IDLE, true);
            this._bonusGameAnimation.visible = true;

            this._bonusGamePyramid.stop(true);
            this._bonusGamePyramid.visible = false;
        } else {
            this._bonusGamePyramid.setImmediately(ANIMATIONS.IDLE, true);
            this._bonusGamePyramid.visible = true;

            this._bonusGameAnimation.stop(true);
            this._bonusGameAnimation.visible = false;
        }
    }

    async playBonusWin() {
        if (this._mode === GAME_MODE.BONUS) {
            await this.playBonusWinAnimations();
        }
    }

    async playFire() {
        await this.fireAnimation.playWin();
    }

    async playBonusWinAnimation(target) {
        target.stop(true);
        await target.setImmediately([ANIMATIONS.WIN, ANIMATIONS.WIN_END]);
        target.addImmediately(ANIMATIONS.IDLE);
    }

    async playBonusWinAnimations() {
        if (this._orientation === ORIENTATIONS.LANDSCAPE) {
            await this.playBonusWinAnimation(this._bonusGameAnimation);
        } else {
            await this.playBonusWinAnimation(this._bonusGamePyramid);
        }
    }

    updateComponentLayout() {
        if (this._mode === GAME_MODE.MAIN) {
            this.setMainGameView();
        } else if (this._mode === GAME_MODE.BONUS) {
            this.setBonusGameView();
        } else {
            throw new Error('Set proper game mode for continue!');
        }
    }

    updateOrientation(orientation) {
        this._orientation = orientation;
        this.updateComponentLayout();
    }

    get isLandscape() {
        return this._orientation === ORIENTATIONS.LANDSCAPE;
    }
}

export default Background;
